export const adaptPerson = (item: IRetailUser): Person => {
	return {
		id: item.id,
		name: item.name,
		email: item.email,
		role: item.role,
		employeeId: item.employee_id,
		store: item.store ?? null,
		archived: item.archived,
		lastsync: item.lastsync,
		createdAt: item.created_at,
		updatedAt: item.updated_at
	};
};

export const adaptPeople = (items: IRetailUser[]): Person[] => {
	return items.map(adaptPerson);
};
